import * as d3 from 'd3-selection'

const borderRadius = '2px'

const dimensions = {
  titleOffset: 18,
  subtitleHeight: 45
}

export default (selection, chart, data, columns, rows, columnScale, rowScale) => {
  selection.each(function () {
    let waffle = d3.select(this)
                   .selectAll('g.waffle-container')
                   .data(data)

    waffle.exit().remove()

    waffle = waffle.enter()
                   .append('g')
                     .attr('class', 'waffle-container')
                     .merge(d3.select(this).selectAll('g.waffle-container'))

    waffle.attr('transform', d => {
            let dim = d.block.dimensions
            return `translate(${dim.x}, ${dim.y})`
          })

    let pocket = waffle.selectAll('rect.pocket')
                       .data(d => d.pockets)

    pocket.enter()
          .append('rect')
          .attr('class', 'pocket is-deemphasizable')
          .on('click', function (e, idx) {
            let d = d3.select(this.parentNode).datum()
              , range = d.block.range
              , point = d.threshold(idx)

            if (!point.clickable) {
              return // not clickable
            }

            if (point.color === 'empty-pocket') {
              return // didn't click a real serie point
            }

            chart.ee.emit('chart-event', 'select:point', point, range)
          })
          .merge(pocket)
          .classed('is-clickable', function (idx) {
            let d = d3.select(this.parentNode).datum()
              , point = d.threshold(idx)
            return point.clickable
          })
          .attr('x', d => columnScale(d % columns))
          .attr('y', d => rowScale(Math.floor(d / columns)))
          .attr('rx', borderRadius)
          .attr('ry', borderRadius)
          .attr('width', columnScale.bandwidth())
          .attr('height', rowScale.bandwidth())
          .select(function (d) {
            // TODO We probably will move this into specific animation objects
            // once we start animating waffle charts
            let threshold = d3.select(this.parentNode).datum().threshold
              , serie = threshold(d)

            d3.select(this)
              .attr('fill', `url(#waffle-colored-gradient-${serie.color})`)
              .classed('deemphasize', serie.deemphasize)

            return this
          })

    // Add the labels
    let title = waffle.selectAll('g.text-title')
                      .data(d => d.title ? [d] : [])
                      .join('g')
                      .attr('class', 'text-title')
                      .attr('transform', function (d) {
                        return `translate(0, ${rowScale.range()[1]})`
                      })
                      .selectAll('text.title')
                      .data(d => [d])

    title.exit().remove()

    title = title.enter()
                 .append('text')
                 .attr('class', 'title')
                 .merge(title)

    title.text(d => d.title)
         .attr('dy', dimensions.titleOffset)

    let total = waffle.selectAll('g.text-total')
                      .data(d => d.totalLabel ? [d] : [])
                      .join('g')
                      .attr('class', 'text-total')
                      .attr('transform', function (d) {
                        return `translate(${columnScale.range()[1]}, ${rowScale.range()[1]})`
                      })
                      .selectAll('text.total')
                      .data(d => [d])

    total.exit().remove()

    total = total.enter()
                 .append('text')
                 .attr('class', 'total')
                 .merge(total)

    total.text(d => d.points[0].formatted)
         .attr('dy', dimensions.titleOffset)

    let subtitle = waffle.selectAll('foreignObject.subtitle')
                      .data(d => d.subtitle ? [d] : [])

    subtitle.exit().remove()

    let subtitleEnter = subtitle.enter()
                                .append('foreignObject')
                                .attr('class', 'subtitle')
    subtitleEnter.append('xhtml:p')

    subtitle = subtitleEnter.merge(subtitle)

    subtitle.attr('transform', function (d) {
              return `translate(0, ${rowScale.range()[1] + dimensions.titleOffset})`
            })
            .attr('width', d => columnScale.range()[1])
            .attr('height', dimensions.subtitleHeight + dimensions.titleOffset)
            .select('p')
            .html(d => d.subtitle)
  })
}

export { dimensions }
